import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class DokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    Roba: string;
    Magacin: string;
    Serija: string;
    DatumIsteka: NgbDate;
    Kolicina: number;
    NabavnaCena: number;
    Ukupno: number;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Roba=input.Roba;
        this.Magacin=input.Magacin;
        this.Serija=input.Serija;
        this.DatumIsteka=input.DatumIsteka;
        this.Kolicina=input.Kolicina;
        this.NabavnaCena=input.NabavnaCena;
        this.Ukupno=input.Ukupno;
        return this;
    }
    Serialize(input:DokumentStavkaView){
        return input;
    }
}